<hr>
<h2>Edit Customer</h2><button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
    <form [formGroup]="myForm" (ngSubmit)="updateCustomer()" novalidate>
        
        <div class="form-group">
            <label for="customercode">Customer Code (optional - autogenerated)</label>
            <div><label>{{this.myForm.value.customercode}}</label></div>      
            <input type="hidden" class="form-control" formControlName="customercode"  id="customercode" />   
        </div>

        <div class="form-group">
            <label for="customername">Customer name</label>  
            @if (myForm.get('customername')?.invalid ) {
                @if (customername?.errors?.['minlength']) {
                    <div class="help-block">
                        Customer Name must be at least 3 characters.
                    </div>
                }
                @if (customername?.errors?.['maxlength']) {
                    <div class="help-block">
                        Customer Name has too many characters.
                    </div>
                }
                @if (customername?.errors?.['required']) {
                    <div class="help-block">
                        Customer name is required.
                    </div>
                }
            }
            <input type="text" class="form-control"  formControlName="customername" id="customername" required />
        </div>

        <div class="form-group" >
            <label for="subsectorcode">Subsector Code</label>
            @if (myForm.get('subsectorcode')?.invalid) {
                @if (subsectorcode?.errors?.['maxlength']) {
                    <div class="help-block">
                        Subsector Code has too many characters.
                    </div>
                }
                @if (subsectorcode?.errors?.['required']) {
                    <div class="help-block">
                        Subsector Code is required.
                    </div>
                }
            }            
            <select id="subsectorcode" formControlName="subsectorcode" required>
                @for (subsector of subsectors; track subsector.code) {
                    <option value = {{subsector.code}}>{{subsector.description}}</option>
                }
            </select>
        </div>


       <div class="form-group">
            <label for="origindate">Origin Date (optional)</label>
            @if (myForm.get('origindate')?.invalid) {
                @if (origindate?.errors?.['maxlength']) {
                    <div class="help-block">
                        Origin Date has too many characters.
                    </div>
                }
                @if (origindate?.errors?.['pattern']) {
                    <div class="help-block">
                        Origin Date must use this pattern: YYYY-MM-DD.
                    </div>
                }
            }            
            <input type="date" class="form-control"  formControlName="origindate" id="origindate" />
        </div>


       <div class="form-group">
            <label for="expirydate">Expiry Date (optional)</label>
            @if (myForm.get('expirydate')?.invalid) {
                @if (expirydate?.errors?.['maxlength']) {
                    <div class="help-block">
                        Expiry Date has too many characters.
                    </div>
                }
                @if (expirydate?.errors?.['pattern']) {
                    <div class="help-block">
                        Expiry Date must use this pattern: YYYY-MM-DD.
                    </div>
                }
            }            
            <input type="date" class="form-control"  formControlName="expirydate" id="expirydate" />
        </div>          
 

        <div class="form-group">
            <label for="addressline1">Address Line 1</label>
            @if (myForm.get('addressline1')?.invalid) {
                @if (addressline1?.errors?.['required']) {
                    <div class="help-block">
                        Address Line 1 is required.
                    </div>
                }
                @if (addressline1?.errors?.['maxlength']) {
                    <div class="help-block">
                        Address Line 1 has too many characters.
                    </div>
                }
                @if (addressline1?.errors?.[',minlength']) {
                    <div class="help-block">
                        Address Line 1 must be at lease 3 characters.
                    </div>
                }
            }            
            <input type="text" class="form-control"  formControlName="addressline1" id="addressline1" />
        </div>

        <div class="form-group">
            <label for="addressline2">Address Line 2 (optional)</label>
        @if (myForm.get('addressline2')?.invalid) {
            <div class="help-block">Address Line 2 has too many characters.</div>
        }            
        <input type="text" class="form-control"  formControlName="addressline2" id="addressline2" />
        </div>


        <div class="form-group">
            <label for="addresszip">Zip</label>
            @if (myForm.get('addresszip')?.invalid) {
                @if (addresszip?.errors?.['maxlength']) {
                    <div class="help-block">
                        Zip has too many characters.
                    </div>
                }
                @if (addresszip?.errors?.['required']) {
                    <div class="help-block">
                        Zip is required.
                    </div>
                }
            }            
            <input type="text" class="form-control"  formControlName="addresszip" id="addresszip" />
        </div>

        <div class="form-group">
            <label for="phone">Phone (optional)</label>
            @if (myForm.get('phone')?.invalid) {
                <div class="help-block">Phone has too many characters.</div>
            }            
            <input type="text" class="form-control"  formControlName="phone" id="phone" />
        </div>

        <div class="form-group">
            <label for="salesareacode">Sales Area code (option - autogenerated)</label>
            @if (myForm.get('salesareacode')?.invalid) {
                <div class="help-block">Sales Code has too many characters.</div>
            }            
            <input type="text" class="form-control"  formControlName="salesareacode" id="salesareacode" />
        </div>

      <div class="form-group" >
             <div class="form-group" >
                <label for="uploaded">Date Uploaded: {{ uploaded?.value == '0000-00-00' ? 'Pending' : (uploaded?.value | date: 'MM/dd/yyyy') }}</label>
        </div>
    
        </div>
        
        <div class="form-group">
            <button [disabled]="!myForm.valid" class="btn btn-primary">Update</button>
        </div>
    </form>
</div>